import { forEach, get } from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import { formatPercentage, getMonthDisplay } from '../../../utils/functions'
import ScrollingTable from '../../Tables/ScrollingTable'

class PeriodicTotalReturns extends PureComponent {
  constructor(props) {
    super(props)

    const performance = get(props, 'periodicPerformance')
    const fundName = get(props, 'name')
    const periodCode = get(props, 'period_code')

    const columns = [{ Header: 'Fund Name', accessor: 'fundName' }]

    const dataHold = []
    dataHold[fundName] = { fundName }

    forEach(performance, (item) => {
      const monthTitle = getMonthDisplay(item.calendar.monthShortName)

      const header =
        (periodCode === '1MO' ? `${monthTitle} ` : '') +
        item.calendar.yearNumber

      columns.push({
        Header: header,
        id: item.calendar.key,
        accessor: item.calendar.key,
        Cell: (props) => (
          <span>
            {typeof props.value === 'number'
              ? formatPercentage(props.value)
              : '--'}
          </span>
        ),
      })

      // sets value for a given month
      dataHold[fundName][item.calendar.key] = item.fundReturn

      // adds benchmark data to array
      forEach(item.indexReturns, (benchmark) => {
        const benchmarkName = benchmark.benchmarkIndex.name
        if (typeof dataHold[benchmarkName] === 'undefined') {
          dataHold[benchmarkName] = { fundName: benchmarkName }
        }
        dataHold[benchmarkName][item.calendar.key] = benchmark.indexReturn
      })
    })

    const data = []
    for (const key in dataHold) {
      data.push(dataHold[key])
    }

    this.state = {
      columns,
      data,
    }
  }

  render() {
    const { tableTitle } = this.props
    const { columns, data } = this.state

    this.scrollingTableOptions = {
      stripedTable: true,
      presentation: this.presentation,
    }

    return (
      <>
        {tableTitle && <h4>{tableTitle}</h4>}
        <ScrollingTable
          data={data}
          columns={columns}
          options={this.scrollingTableOptions}
          otherClassName="table-headers--centered"
        />
      </>
    )
  }
}

PeriodicTotalReturns.propTypes = {
  data: PropTypes.any,
  periodCode: PropTypes.string,
}

export default PeriodicTotalReturns